import { SET_SHOW_NOTIFICATION_MENU } from '../../constants/action-types';


export function setShowNotificationMenu(payload: boolean) {
    return { type: SET_SHOW_NOTIFICATION_MENU, payload }
}